module.exports = __webpack_public_path__ + "img/Fanta Orange Can.54a043ca.png";